/** @format */

import React, { FunctionComponent, ReactElement, useEffect, useState } from 'react';
import { Dialog, DialogActions, DialogContent, DialogTitle } from '@material-ui/core';
import I18n from '../../../components/Translate/I18n';
import GridContainer from '../../../components/Grid/GridContainer';
import GridItem from '../../../components/Grid/GridItem';
import CustomTextButtom from '../../../components/Buttons/CustomTextButton';
import { useDispatch } from 'react-redux';
import { ItemLoaders } from '../../../core/loaders/ItemLoaders';
import { FormGeneralHelper } from '../../../helpers/FormGeneral';
import { SimpleSelect } from '../../../components/Adescom/SimpleSelect';
import { DateHelperTs } from '../../../helpers/DateHelperTs';
import PlatformMsisdnPoolNumber from '../../../interfaces/platform/PlatformMsisdnPoolNumber';
import { numberStateIdMapInt } from '../../lib/search/MsisdnStateHelper';

type MsisdnPoolsChangeStatusType = {
    msisdn: PlatformMsisdnPoolNumber;
    open: boolean;
    reload(): void;
    close(): void;
};

export const MsisdnPoolsChangeStatus: FunctionComponent<MsisdnPoolsChangeStatusType> = ({ open, close, msisdn, reload }): ReactElement => {
    const dispatch = useDispatch();
    const [currentStatus, setCurrentStatus] = useState<number>(msisdn.numberState);

    useEffect(() => {
        if (open) {
            setCurrentStatus(msisdn.numberState);
        }
    }, [open, msisdn]);

    const setNewStatus = (event: React.ChangeEvent<HTMLSelectElement>): void => {
        setCurrentStatus(parseInt(String(event.target.value)));
    };

    const changeStatus = (): void => {
        const itemLoader = new ItemLoaders(dispatch);
        if (currentStatus === numberStateIdMapInt.ARCHIVE) {
            msisdn.deleted = true;
            msisdn.archivingDate = DateHelperTs.getCurrentDateTime();
        }
        if (currentStatus !== numberStateIdMapInt.LOCK && msisdn.lockTime) {
            msisdn.lockTime = null;
        }
        if (currentStatus !== numberStateIdMapInt.ARCHIVE && msisdn.deleted) {
            msisdn.deleted = false;
            msisdn.archivingDate = null;
        }
        msisdn.numberState = numberStateIdMapInt.FREE;
        itemLoader.putWithCallback(
            FormGeneralHelper.getByUri(msisdn['@id']),
            'update-status-time-msisdn',
            msisdn,
            (data: PlatformMsisdnPoolNumber): void => {
                reload();
                close();
            },
            { propagateDataToCallback: true, dispatchAfterCallback: false }
        );
    };

    return (
        <Dialog fullWidth={true} maxWidth="sm" open={open} aria-labelledby="alert-dialog-title" aria-describedby="alert-dialog-description">
            <DialogTitle id="alert-dialog-title">
                <I18n trans="pools:msisdn.change_status" />
            </DialogTitle>
            <DialogContent>
                <GridContainer>
                    <GridItem xs={12}>
                        <I18n trans="pools:msisdn.change_status_to_free" />
                        {/*<SimpleSelect*/}
                        {/*    callback={setNewStatus}*/}
                        {/*    label={'pools:msisdn.change_status_list'}*/}
                        {/*    required={true}*/}
                        {/*    elements={new MsisdnStateDetailH().getStatus()}*/}
                        {/*    dispatchName={'not-dispatch'}*/}
                        {/*    selectedValue={currentStatus}*/}
                        {/*/>*/}
                    </GridItem>
                </GridContainer>
            </DialogContent>
            <DialogActions>
                <CustomTextButtom callback={close} callbackParam={{}} label="general:common.close" size="sm" />
                <CustomTextButtom callback={changeStatus} callbackParam={{}} label="general:common.ok" size="sm" />
            </DialogActions>
        </Dialog>
    );
};
